<h1 mat-dialog-title>Logged Out</h1>
<div mat-dialog-content>Your Session timed out, Please Login Again!</div>
<div mat-dialog-actions>
  <button align-items: center mat-button mat-dialog-close>Close</button>
</div>